import React, { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebtCollectionIntegration } from '../../hooks/useDebtCollectionIntegration'
import { useMobilePayIntegration } from '../../hooks/useMobilePayIntegration'
import { IntegrationItem } from '../../types/integrationItem'
import { DebtCollectionModalsGroup } from '../DebtCollectionModalsGroup'
import { IntegrationsList } from '../IntegrationsList'
import { MobilePayModalsGroup } from '../MobilePayModalsGroup'
import { StripeModalsGroup } from '../StripeModalsGroup'

export const InvoicesIntegrationsList = (): ReactElement => {
  const { t } = useTranslation()
  const mobilePayIntegration = useMobilePayIntegration()
  const debtCollectionIntegration = useDebtCollectionIntegration()

  const items: IntegrationItem[] = useMemo(
    () => [mobilePayIntegration, debtCollectionIntegration],
    [mobilePayIntegration, debtCollectionIntegration],
  )

  return (
    <>
      <IntegrationsList title={t('integrations.list.title.take_care')} items={items} />
      <DebtCollectionModalsGroup />
      <StripeModalsGroup />
      <MobilePayModalsGroup />
    </>
  )
}
